<template>
  <div>
    <div class="tw-flex tw-justify-between tw-my-4">
      <div>
       

        <vs-select
            label="Sayfada Gösterilecek Kayıt Sayısı"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>
      </div>

      <vs-paginator
          v-if="meta"
          :meta="meta"
          @change="handlePageChange"
      ></vs-paginator>

    </div>

    <vs-table stripe :data="list">
      <template slot="header">
        <div class="tw-w-full tw-flex tw-items-center tw-justify-between">
          <h3>Uygulama Erişim Bilgileri</h3>
          <vs-button
              radius
              size="small"
              color="warning"
              type="border"
              icon="mdi-cached"
              @click="page = 1; get();"
          >
          </vs-button>
        </div>
      </template>
      <template slot="thead">
       
        <vs-th>Tarih</vs-th>
        <vs-th>Tarayıcı</vs-th>
        <vs-th>URL</vs-th>
       
        <vs-th>İşletim Sistemi</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="(item, i) in data" :key="i" >
          <vs-td>
            {{ i + 1 }}.
          </vs-td>
          <vs-td>
            <div>{{ formatDate(item.createdAt) }}</div>
            <small class="tw-ml-1 tw-italic">~ {{ formatDateInterval(item.createdAt) }}</small>
          </vs-td>
          <vs-td :data="item.browser">
            <div>{{ item.browser }}</div>
          </vs-td>
          <vs-td :data="item.url">
            <div>{{ item.url }}</div>
            <small>{{ item.domain }}</small>
          </vs-td>
         
          <vs-td :data="item.os">
            <div>{{ item.os }}</div>
            <small class="tw-ml-1 tw-italic">~ {{ item.os_version }}</small>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import { analyticsMixin } from "@/libs/analytics/analyticsMixin";

  export default {
    name: "Analytics-TrafficList",
    title: "Analitik - Erişim Listesi",

    mixins: [
      analyticsMixin,
    ],

    data() {
      return {
        decoratorKey: 'traffic',
        pageSize: 20,
      }
    },
  }
</script>

<style scoped>

</style>